/* eslint-disable react/prop-types */
import React from "react";

import styles from "./CustomProductOptionBrandRefresh.module.css";

const plusIcon = require("./imgs/plus-icon.svg");
const plusIconDisabled = require("./imgs/plus-icon-disabled.svg");
const minusIcon = require("./imgs/minus-icon.svg");

const BrandRefreshQuantityControl = ({
  quantity = 0,
  onChangeAdd,
  onChangeRemove,
  oos = null,
  addDisabled = false,
}) => {
  const isAddDisabled = oos === 1 || addDisabled;
  if (quantity > 0) {
    return (
      <div className={styles.pillControl} data-part="qty-control">
        <button
          type="button"
          aria-label="Decrease quantity"
          data-part="qty-btn"
          onClick={onChangeRemove}
          className={styles.pillBtn}
        >
          <img src={minusIcon} alt="" aria-hidden="true" />
        </button>
        <span className={styles.pillValue} data-part="qty-value">
          {quantity}
        </span>
        <button
          type="button"
          aria-label="Increase quantity"
          data-part="qty-btn"
          onClick={isAddDisabled ? undefined : onChangeAdd}
          disabled={isAddDisabled}
          className={styles.pillBtn}
        >
          <img src={plusIcon} alt="" aria-hidden="true" />
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      aria-label="Add to order"
      data-part="add-btn"
      onClick={isAddDisabled ? undefined : onChangeAdd}
      disabled={isAddDisabled}
      className={styles.circleBtn}
    >
      <img src={isAddDisabled ? plusIconDisabled : plusIcon} alt="" aria-hidden="true" />
    </button>
  );
};

export default BrandRefreshQuantityControl;